import classNames from 'classnames'
import type { FunctionComponent } from 'react'

import styles from './article-apps.module.scss'
import { AppButton } from '../../components/app-button'

/**
 * Displays AppStore and GooglePlay buttons.
 */
export const ArticleApps: FunctionComponent<Props> = ({
    background = 'light',
}) => (
    <div
        className={classNames(
            styles.section,
            styles.apps,
            background == 'light' ? styles.light : styles.dark,
        )}
    >
        {(['GooglePlay', 'AppStore'] as const).map((type) => (
            <div key={type} className={styles.app}>
                <AppButton type={type} />
            </div>
        ))}
    </div>
)

interface Props {
    background?: 'light' | 'dark'
}
